import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';
import { addAdminType } from 'types/UsersTypes';


type EditAdminType = addAdminType & {
  uuid: string;
};
const useEditAdmin = (
  options?: UseMutationOptions<any, Error, EditAdminType, any>
) => {
  return useMutation({
    ...options,
    mutationKey: ['editAdmin'],
    mutationFn: async ({
      uuid,
      firstName,
      lastName,
      email,
    }) => {
      return axiosInstance.put(`/users/admin/${uuid}`, {
        firstName,
        lastName,
        email,
      }).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Przetwarzanie edycji administratora...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'edit-admin',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Informacje o administratorze zostały zaktualizowane',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'edit-admin',
      });
      queryClient.invalidateQueries({ queryKey: ['users'] }); 
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas edytowania informacji o administratorze',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'edit-admin',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useEditAdmin;
